import PublishIcon from '@mui/icons-material/Publish';
import TextButton from '../TextButton'

export default function ExportButton({onClick}){

    return(
        <TextButton startIcon={<PublishIcon />} clickHandler={onClick}>Import Data</TextButton>
    );
}
